import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import Popover from "react-tiny-popover";
import Icon from "../Icon";

const Term = ({ term }) => {
  const popoverEl = useRef(null);
  const [open, setOpen] = useState(false);

  const toggleOpen = event => {
    event.preventDefault();
    setOpen(!open);
  };

  const Definition = () => {
    return (
      <div className="Glossary-definition">
        <div className="Glossary-definition-inner">
          <div className="Glossary-definition-triangle"></div>
          <p>{term.definition}</p>
        </div>
      </div>
    );
  };

  return (
    <Popover
      isOpen={open}
      onClickOutside={() => setOpen(false)}
      contentDestination={popoverEl.current}
      contentLocation={{ top: -30, left: 0 }}
      style={{ maxWidth: "100%" }}
      disableReposition
      content={<Definition />}
    >
      <div className="u-relative">
        <button className="Glossary-term-btn" onClick={event => toggleOpen(event)}>
          <span className="Glossary-term">{term.title}</span>
        </button>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            width: "100%"
          }}
          ref={popoverEl}
        ></div>
      </div>
    </Popover>
  );
};

Term.propTypes = {
  term: PropTypes.object.isRequired
};

export default Term;
